import {Service} from '../../domain/scan/entities/Service';
import {ServiceStatus, ServiceStatusType} from '../../domain/scan/entities/ServiceStatus';

interface EligibilityItem {
  benefit_id?: number;
  case_user_id?: number;
  benefit?: {
    id?: number;
    name?: string;
    [key: string]: any;
  };
  program?: {
    id?: number;
    name?: string;
    [key: string]: any;
  };
  status?: string;
  status_oject?: {
    name?: string;
    [key: string]: any;
  };
  elegible?: boolean;
  validated?: boolean;
  assignment_id?: number | null;
  rules_data?: Array<{
    result?: boolean;
    [key: string]: any;
  }>;
  [key: string]: any;
}

/**
 * Maps an eligibility item from API to Service entity
 * @param item - Eligibility item from API
 * @returns Service entity with optional eligibility data
 */
export const mapEligibilityItemToService = (
  item: EligibilityItem,
): Service & {eligibility?: any} => {
  const benefit = item.benefit || {};
  const program = benefit.program || item.program || {};

  // Determine service status based on eligibility
  let status: ServiceStatusType = ServiceStatus.INACTIVE;
  if (item.elegible === true) {
    status = ServiceStatus.ACTIVE;
  } else if (item.status === '3' || item.status === '4') {
    // Does Not Comply or Not Eligible
    status = ServiceStatus.INACTIVE;
  } else if (item.status === '2') {
    // Partially Eligible
    status = ServiceStatus.ACTIVE;
  } else if (item.status === '1') {
    // Pre-Elegible
    status = ServiceStatus.ACTIVE;
  }

  // Count passed rules
  const passedRules =
    item.rules_data?.filter((rule: any) => rule.result === true).length || 0;
  const totalRules = item.rules_data?.length || 0;

  return {
    id: benefit.id?.toString() || item.benefit_id?.toString() || 'unknown',
    name: benefit.name || `Beneficio #${item.benefit_id}`,
    description: `${program.name || 'Sin programa'} - ${
      item.status_oject?.name || 'Estado desconocido'
    }`,
    category: program.name || 'Sin categoría',
    providerId: program.id?.toString() || '',
    providerName: program.name || 'Sin proveedor',
    price: 0,
    currency: 'COP',
    availableRedemptions: item.elegible === true ? 1 : 0,
    totalRedemptions: totalRules,
    status: status,
    programId: program.id?.toString() || '',
    benefitId: benefit.id?.toString() || item.benefit_id?.toString() || '',
    // Assignment data (null means no active assignment yet)
    assignment: item.assignment_id != null
      ? {assignmentId: item.assignment_id, caseUserId: item.case_user_id}
      : null,
    eligibility: {
      status: item.status,
      statusName: item.status_oject?.name,
      elegible: item.elegible,
      validated: item.validated,
      passedRules,
      totalRules,
      rulesData: item.rules_data,
    },
  } as Service & {eligibility?: any; assignment?: any};
};

/**
 * Maps an array of eligibility items to Service entities
 * @param items - Array of eligibility items from API
 * @param filterActive - If true, only returns active services (default: false)
 * @returns Array of Service entities
 */
export const mapEligibilityItemsToServices = (
  items: EligibilityItem[],
): (Service & {eligibility?: any})[] => {
  return items
    .filter(item => item.elegible === true)
    .map(item => mapEligibilityItemToService(item));
};

